import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_2 = {
  class: "div-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_assets_card = _resolveComponent("assets-card");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_assets_table = _resolveComponent("assets-table");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_card = _resolveComponent("el-card");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      size: "small",
      inline: true,
      model: _ctx.form,
      class: "assets-form"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "关键字"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.form.keys,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.form.keys = $event),
          placeholder: "素材相关关键字"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "投放点位"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: _ctx.form.posName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.form.posName = $event),
          options: _ctx.posData,
          props: $setup.cascader,
          "show-all-levels": false,
          onChange: $setup.posChange
        }, null, 8, ["modelValue", "options", "props", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "需求人姓名"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.form.needUser,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.form.needUser = $event),
          placeholder: "需求人姓名"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "商品编码"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.form.offerId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.form.offerId = $event),
          placeholder: "关联商品的OFFER_ID"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "商品链接"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.form.busiLink,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.form.busiLink = $event),
          placeholder: "关联商品的业务链接"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "文件类型"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.form.srcTyp,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.form.srcTyp = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            value: 1,
            label: "图片"
          }), _createVNode(_component_el_option, {
            value: 2,
            label: "音频"
          }), _createVNode(_component_el_option, {
            value: 3,
            label: "视频"
          }), _createVNode(_component_el_option, {
            value: 4,
            label: "文本"
          }), _createVNode(_component_el_option, {
            value: 5,
            label: "源文件"
          }), _createVNode(_component_el_option, {
            value: 7,
            label: "短信"
          }), _createVNode(_component_el_option, {
            value: 6,
            label: "其它"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "文件子类型"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.form.subtype,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.form.subtype = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            value: "监测",
            label: "监测"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "素材状态"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.form.status,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.form.status = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            value: 0,
            label: "已失效"
          }), _createVNode(_component_el_option, {
            value: 1,
            label: "生效中"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.onSubmit
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("搜索", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          onClick: $setup.reset
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("重置", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
      size: "small",
      type: "primary",
      onClick: _cache[8] || (_cache[8] = $event => $setup.handleBatchUpdateAssetsStatus(1))
    }, {
      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("批量上线", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      size: "small",
      onClick: _cache[9] || (_cache[9] = $event => $setup.handleBatchUpdateAssetsStatus(0))
    }, {
      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("批量下线", -1)]))]),
      _: 1
    })]), _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.activeName = $event),
      onTabClick: $setup.tabsClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        name: "0"
      }, {
        label: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createElementVNode("span", null, [_createElementVNode("i", {
          class: "el-icon-menu"
        }), _createTextVNode(" 卡片展示")], -1)]))]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_assets_card, {
          assetsList: _ctx.assetsList,
          onBatchUpdate: $setup.fetchData,
          onSelectChange: $setup.selectChange,
          ref: "assetsCardRef"
        }, null, 8, ["assetsList", "onBatchUpdate", "onSelectChange"])])), [[_directive_loading, _ctx.loading]])]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        name: "1"
      }, {
        label: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createElementVNode("span", null, [_createElementVNode("i", {
          class: "el-icon-document"
        }), _createTextVNode(" 列表展示")], -1)]))]),
        default: _withCtx(() => [_withDirectives(_createVNode(_component_assets_table, {
          assetsList: _ctx.assetsList,
          onBatchUpdate: $setup.fetchData,
          ref: "assetsTableRef"
        }, null, 8, ["assetsList", "onBatchUpdate"]), [[_directive_loading, _ctx.loading]])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])]), _createVNode(_component_el_pagination, {
      class: "el-pagination-wrap",
      background: "",
      "hide-on-single-page": true,
      total: _ctx.total,
      "page-size": _ctx.form.pageSize,
      modelValue: _ctx.form.pageNum,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.form.pageNum = $event),
      onCurrentChange: _cache[12] || (_cache[12] = v => _ctx.form.pageNum = v),
      onPrevClick: _cache[13] || (_cache[13] = v => _ctx.form.pageNum = v),
      onNextClick: _cache[14] || (_cache[14] = v => _ctx.form.pageNum = v)
    }, null, 8, ["total", "page-size", "modelValue"])]),
    _: 1
  });
}